<template>
  <div id="app">
    <NetworkStatus />
    <UpdatePrompt />
    <InstallPrompt />
    <router-view/>
  </div>
</template>

<script>
import NetworkStatus from '@/components/NetworkStatus.vue'
import UpdatePrompt from '@/components/UpdatePrompt.vue'
import InstallPrompt from '@/components/InstallPrompt.vue'

export default {
  components: {
    NetworkStatus,
    UpdatePrompt,
    InstallPrompt
  }
}
</script>

<style lang="stylus">

</style>
